import React from 'react';
import { string } from 'prop-types';
import SVG from 'react-inlinesvg';

SvgParser.propTypes = {
  title: string,
  src: string
};

function SvgParser(props) {
  const { title, src } = props;
  return (
    <SVG
      cacheRequests={true}
      description={title}
      src={src}
      title={title}
    />
  );
}

export default SvgParser;
